import callApi from 'apis';
import CONFIG_API from 'apis/EndpointConfig';

const apiGetListUser = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/user/getListUser`,
  'post',
  params,
);
const getUserInfo = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/user/getUserInfo`,
  'post',
   params,
);
const getAllMenu = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/system/getAllMenu`,
  'get',
  params,
);
const changeStatusUser = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/user/updateStatusUser`,
  'post',
  params,
);
const resetPass = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/user/resetPass`,
  'post',
  params,
);

export {
  apiGetListUser,
  getUserInfo,
  getAllMenu,
  changeStatusUser,
  resetPass,
};
